import axios from 'axios';
import { baseUrl } from './config';

// Prepare axios instance
const accessToken = localStorage.getItem('access_token');
const request = axios.create({
  baseURL: baseUrl,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
    'Access-Control-Allow-Origin': '*',
  },
});

request.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error.response.status == 401) {
      localStorage.removeItem('access_token');
      location.href = '/giris-yap';
    }
    return Promise.reject(error);
  }
);

export default request;
